module.exports = __webpack_public_path__ + "static/img/commercial.5e14ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/risk/commercial.png
// module id = oWOO
// module chunks = 16